import { useLazyQuery, useQuery } from "@apollo/client/react"; import { useState, useEffect } from 'react';

import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { fieldsToSearchByTab } from '../constants/fieldsToSearchByTab';
import moment from 'moment';

export const useGetFilters = () => {
  const [delegaciones, setDelegaciones] = useState([]);
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);

  const storageId = sessionStorage.getItem('idUsuario');

  const { filters, handleChangeFilters } = usePersistFilters({
    idDelegacion: delegacionOrigen,
    fechaDesde: moment().subtract(1, 'months'),
    fechaHasta: moment(),
    txtFiltro: '',
    activeTabEnum: 'ASIGNACION',
    estado: -1 // Estado por defecto -1 = Sin Asignación
  }, "riNotificationFilters");

  const [getDelegaciones, { loading: delegacionesLoading, data: delegacionesData }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  const [getDelegacionOrigen, { loading: delegacionOrigenLoading, data: delegacionOrigenData }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId) } });
    }
    getDelegacionOrigen({ variables: { idUsuario: JSON.parse(storageId) } });
  }, [storageId]);

  useEffect(() => {
    if (!delegacionesData) return;

    setDelegaciones(adaptDelegacionArray(delegacionesData));
  }, [delegacionesData]);

  useEffect(() => {
    if (!delegacionOrigenData?.usuarioFull?.success) return;
    const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
    sessionStorage.setItem('delegacionOrigen', deleg);
    setDelegacionOrigen(deleg);

    if (filters.idDelegacion == 0)
      handleChangeFilters('idDelegacion', deleg);
  }, [delegacionOrigenData]);

  const normalize = (val) => val?.toString().toUpperCase().trim() || '';

  const applyTextFilter = (data, textFilter, activeTabEnum, estado, estadosOptions) => {
    const inputBuscar = textFilter?.trim().toUpperCase();

    if (inputBuscar === "") return data;

    const fieldsToSearch = fieldsToSearchByTab[activeTabEnum] || [];

    const dataFiltered = data?.filter((row) => {
      return fieldsToSearch.some((fieldName) => {
        if (fieldName === 'profesionalASignado' && activeTabEnum === 'ASIGNACION' && estado !== -2) return false;

        const value = normalize(row[fieldName]);
        return value.includes(inputBuscar);
      });
    });

    return dataFiltered;
  };

  const applyClientSideFilters = (data, textFilter, activeTabEnum, estado, estadosOptions) => {
    const dataFilteredByText = applyTextFilter(data, textFilter, activeTabEnum, estado, estadosOptions);

    // const dataFilteredByEstadoPaciente = applyEstadoPacienteFilter(
    //   dataFilteredByText,
    //   estadoFilter
    // );
    // return dataFilteredByEstadoPaciente;

    return dataFilteredByText;
  };

  return {
    delegacionLoading: delegacionOrigenLoading || delegacionesLoading,
    delegaciones,
    delegacionOrigen,
    filters,
    handleChangeFilters,
    applyTextFilter,
    applyClientSideFilters
  };
};